import '../../styles/sections/section-steps.scss'
import $ from 'jquery'
import 'slick-carousel'
import {register} from "@shopify/theme-sections"

$(`.steps-block-slider`).not(`.slick-initialized`).slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 1,
                arrows: true,
                dots: true,
            },
        },
    ],
})
